module.exports = __webpack_public_path__ + "static/media/check-box_gray_on.0b4eebcc.svg";